const KEY = "hp_signin_prompt_dismissed";
const DAY_MS = 24 * 60 * 60 * 1000;

/** How long every sign-in prompt stays away once the listener has closed one */
export const PROMPT_QUIET_DAYS = 14;

/**
 * When a sign-in prompt was last closed (milliseconds; 0 if never). A device setting, not personal data.
 * Earlier versions stored "1" for "closed for good": that counts as closed now, so the quiet time starts over.
 */
export const readPromptDismissedAt = (now = Date.now()): number => {
    try {
        const stored = localStorage.getItem(KEY);
        if (stored === "1") {
            writePromptDismissedAt(now);
            return now;
        }
        const value = Number(stored);
        return Number.isFinite(value) && value > 0 ? value : 0;
    } catch {
        return 0;
    }
};

export const writePromptDismissedAt = (time: number) => {
    try {
        localStorage.setItem(KEY, String(time));
    } catch {
        // Blocked storage: the prompts then come back on the next visit
    }
};

/** True while the quiet time after a closed prompt has not passed */
export const isPromptQuiet = (dismissedAt: number, now = Date.now()): boolean =>
    dismissedAt > 0 && now - dismissedAt < PROMPT_QUIET_DAYS * DAY_MS;
